module.exports = __webpack_public_path__ + "img/search-1.ce56c77b.svg";